export const ACTION_ADD_SITES = 'ACTION_ADD_SITES';

export const ACTION_SET_CURRENT_SITE_ID = 'ACTION_SET_CURRENT_SITE_ID';

export const ACTION_LOAD_SITES_WITH_ALIASES__REQUEST = 'ACTION_LOAD_SITES_WITH_ALIASES__REQUEST';
export const ACTION_LOAD_SITES_WITH_ALIASES__SUCCESS = 'ACTION_LOAD_SITES_WITH_ALIASES__SUCCESS';
export const ACTION_LOAD_SITES_WITH_ALIASES__FAIL = 'ACTION_LOAD_SITES_WITH_ALIASES__FAIL';

export const ACTION_LOAD_ACTIVE_SITES__REQUEST = 'ACTION_LOAD_ACTIVE_SITES__REQUEST';
export const ACTION_LOAD_ACTIVE_SITES__SUCCESS = 'ACTION_LOAD_ACTIVE_SITES__SUCCESS';
export const ACTION_LOAD_ACTIVE_SITES__FAIL = 'ACTION_LOAD_ACTIVE_SITES__FAIL';

export const ACTION_LOAD_SITE__REQUEST = 'ACTION_LOAD_SITE__REQUEST';
export const ACTION_LOAD_SITE__SUCCESS = 'ACTION_LOAD_SITE__SUCCESS';
export const ACTION_LOAD_SITE__FAIL = 'ACTION_LOAD_SITE__FAIL';

export const ACTION_SWITCH_SITE_STATUS__REQUEST = 'ACTION_SWITCH_SITE_STATUS__REQUEST';
export const ACTION_SWITCH_SITE_STATUS__SUCCESS = 'ACTION_SWITCH_SITE_STATUS__SUCCESS';
export const ACTION_SWITCH_SITE_STATUS__FAIL = 'ACTION_SWITCH_SITE_STATUS__FAIL';

export const ACTION_DELETE_SITE__REQUEST = 'ACTION_DELETE_SITE__REQUEST';
export const ACTION_DELETE_SITE__SUCCESS = 'ACTION_DELETE_SITE__SUCCESS';
export const ACTION_DELETE_SITE__FAIL = 'ACTION_DELETE_SITE__FAIL';
